import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import "./CreateCountry.scss";
import { PaisesService } from "../../services/paises.service";
import { PaisJefe } from "../../models/paisJefe.model";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { Checkbox, Input } from "@progress/kendo-react-inputs";
import Loading from "../shared/loading/Loading.component";

const paisesName: string[] = [
    "Argentina",
    "Bahamas",
    "Barbados",
    "Belice",
    "Bolivia",
    "Brasil",
    "Chile",
    "Colombia",
    "Costa Rica",
    "Ecuador",
    "El Salvador",
    "Guatemala",
    "Guyana",
    "Haití",
    "Honduras",
    "Jamaica",
    "México",
    "Nicaragua",
    "Panamá",
    "Paraguay",
    "Perú",
    "República Dominicana",
    "Surinam",
    "Trinidad y Tobago",
    "Uruguay",
    "Venezuela",
];
const paisesCode: string[] = [
    "AR",
    "BH",
    "BA",
    "BL",
    "BO",
    "BR",
    "CH",
    "CO",
    "CR",
    "EC",
    "ES",
    "GU",
    "GY",
    "HA",
    "HO",
    "JA",
    "ME",
    "NI",
    "PN",
    "PR",
    "PE",
    "DR",
    "SU",
    "TT",
    "UR",
    "VE",
];
const paisesCoin: string[] = [
    "ARS",
    "BSD",
    "BBD",
    "BZD",
    "BOB",
    "BRL",
    "CLF",
    "COP",
    "CRC",
    "USD",
    "SVC",
    "GTQ",
    "GYD",
    "HTG",
    "HNL",
    "JMD",
    "MXN",
    "NIO",
    "PAB",
    "PYG",
    "PEN",
    "DOP",
    "SRD",
    "TTD",
    "UYU",
    "VEF",
    "EUR",
    "GBP",
];
const pais: PaisJefe = {
    oid: 0,
    pais: "",
    codigo: "",
    jefeEquipo: "",
    moneda: "",
    oidJefeEquipo: 0,
    optimisticLockField: true,
};

export const CreateCountry = () => {
    const paisesService = PaisesService({ locale: "en" });
    const [isUpdate, setIsUpdate] = useState(false);
    const [paisPorId, setPaisPorId] = useState<PaisJefe>(pais);
    const [loading, setLoading] = useState<boolean>(false);
    const navigate = useNavigate();

    const { id }: any = useParams();
    useEffect(() => {
        function getPaisId(countryId: number) {
            setLoading(true);
            paisesService
                .getPaisesPorId(countryId)
                .then((response) => {
                    setPaisPorId(response.data);
                    setLoading(false);
                })
                .catch((error) => console.error(error));
        }
        if (id) {
            setIsUpdate(true);
            getPaisId(id);
        } else {
            setIsUpdate(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);
    
    function updatePaises(e: any) {
        e.preventDefault();
        paisesService
            .updatePaises(paisPorId)
            .then((response) => {
                navigate("/admin-users/countries");
            })
            .catch((error) => console.error(error));
    }
    function createPaises(e: any) {
        e.preventDefault();
        paisesService
            .createPaises(paisPorId)
            .then((response) => {
                navigate("/admin-users/countries");
            })
            .catch((error) => console.error(error));
    }
    function handlerChange({ target }: any) {
        const { value, name } = target;
        switch (name) {
            case "nombre":
                setPaisPorId({ ...paisPorId, pais: value });
                break;
            case "codigo":
                setPaisPorId({ ...paisPorId, codigo: value });
                break;
            case "moneda":
                setPaisPorId({ ...paisPorId, moneda: value });
                break;
            case "jefeEquipo":
                setPaisPorId({ ...paisPorId, jefeEquipo: value });
                break;
            case "jefeActivo":
                setPaisPorId({ ...paisPorId, optimisticLockField: value });
                break;
            default:
                break;
        }
    }

    return (
        <>
            <div className="first--cont2">
                {loading ? (
                    <div className="loading-comp">
                        <Loading />
                    </div>
                ) : (
                    <div className="countries--container">
                        {isUpdate ? <p>Actualizar país</p> : <p>Crear país</p>}
                        <div className="inputs--container container">
                            <form
                                onSubmit={
                                    isUpdate ? updatePaises : createPaises
                                }
                                className="row"
                                action=""
                            >
                                <div className="each col-md-6 col-12">
                                    <label>Nombre</label>
                                    <ComboBox
                                        className="country--input"
                                        required
                                        name="nombre"
                                        data={paisesName}
                                        value={paisPorId.pais}
                                        onChange={handlerChange}
                                        disabled={isUpdate ? true : false}
                                        placeholder="Nombre del país"
                                    />
                                </div>
                                <div className="each col-md-6 col-12">
                                    <label>Código</label>
                                    <ComboBox
                                        required
                                        name="codigo"
                                        data={paisesCode}
                                        value={paisPorId.codigo}
                                        onChange={handlerChange}
                                        disabled={isUpdate ? true : false}
                                        placeholder="Código del país"
                                    />
                                </div>
                                <div className="each col-md-6 col-12">
                                    <label htmlFor="JefeEquipo">
                                        Jefe del equipo
                                    </label>
                                    <Input
                                        required
                                        name="jefeEquipo"
                                        value={paisPorId.jefeEquipo}
                                        placeholder="Nombre del jefe de equipo"
                                        onChange={handlerChange}
                                    />
                                </div>
                                <div className="each col-md-6 col-12">
                                    <label>Moneda</label>
                                    <ComboBox
                                        required
                                        name="moneda"
                                        data={paisesCoin}
                                        value={paisPorId.moneda}
                                        onChange={handlerChange}
                                        placeholder="Código del país"
                                    />
                                </div>
                                <Checkbox
                                    className="col-md-6 col-12"
                                    name="jefeActivo"
                                    value={paisPorId.optimisticLockField}
                                    label={"Jefe de equipo activo"}
                                    onChange={handlerChange}
                                />
                                <div className="buttons-cont2">
                                    <Link
                                        className="link--to--country"
                                        to="/admin-users/countries"
                                    >
                                        <button className="btn-back">
                                            Volver
                                        </button>
                                    </Link>
                                    {isUpdate ? (
                                        <button className="btn-create">
                                            Actualizar País
                                        </button>
                                    ) : (
                                        <button className="btn-create">
                                            Crear País
                                        </button>
                                    )}
                                </div>
                            </form>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};
